import { Icon, Modal } from 'Components';
import Button from 'LearningManager/components/Button';
import styles from './AssignmentSuccessModal.module.scss';

interface AssignmentSuccessModalProps {
	visible: boolean;
	onClose: () => void;
}

const AssignmentSuccessModal: React.FC<AssignmentSuccessModalProps> = ({
	visible,
	onClose
}) => {
	return (
		<Modal
			visible={visible}
			onCancel={onClose}
			footer={
				<div className={styles.footer}>
					<Button
						size="small"
						className="cta-prominent"
						onClick={onClose}
					>
						View assignments
					</Button>
				</div>
			}
			centered
			// width={550}
			maskClosable
		>
			<div className={styles.container}>
				<div className={styles.iconWrap}>
					<div className={styles.check}>
						<Icon type="check" role="img" />
					</div>
				</div>
				<div className={styles.title}>
					Courses Assigned Successfully
				</div>
				<div className={styles.description}>
					The selected courses have been assigned successfully. You
					can track progress any time from the Assignments panel.
				</div>
			</div>
		</Modal>
	);
};

export default AssignmentSuccessModal;
